export default __webpack_public_path__ + "static/media/DERS-18.e02ffc52.pdf";